module.exports = __webpack_public_path__ + "components/home-header/static/header-5--medium@2x-8344f533574b592ead916e43cc842f65.jpg";